import React, { useEffect, useState } from "react";
import { PageTitle, PageWrapperTwoColumn } from "@cinesys/ui/components";
import PluginInstanceForm from "./PluginInstanceForm";
import PluginInstanceList from "./PluginInstanceList";
import { Route, Routes, useParams } from "react-router-dom";
import AddPluginList from "./AddPluginList";
import LegacyComponentView from "./LegacyComponentView";

export interface Status {
  status: string;
  message?: string;
}

const PluginInstanceEditScreen = () => {
  const { systemDomainId } = useParams();
  const [editedPluginInstances, setEditedPluginInstances] = useState<
    Record<string, PluginInstanceItem>
  >({});
  const [statuses, setStatuses] = useState<Record<string, Status>>({});
  const onChange = (pluginInstance: PluginInstanceItem) => {
    setEditedPluginInstances((prev) => ({
      ...prev,
      [pluginInstance.id]: pluginInstance,
    }));
  };

  useEffect(() => {
    setEditedPluginInstances({});
    setStatuses({});
  }, [systemDomainId]);

  return (
    <>
      <PageTitle
        title="Plugins"
        dirty={Object.values(statuses).some(({ status }) => status === "dirty")}
      ></PageTitle>

      <PageWrapperTwoColumn minWidth="1030px">
        <PluginInstanceList
          editedPluginInstances={editedPluginInstances}
          statuses={statuses}
        />
        <Routes>
          <Route
            path="new"
            element={
              <AddPluginList
                onAdd={(pluginInstance) => {
                  onChange(pluginInstance);
                  setStatuses((prev) => ({
                    ...prev,
                    [pluginInstance.id]: { status: "dirty" },
                  }));
                }}
              />
            }
          />
          <Route path="legacy/:componentId" element={<LegacyComponentView />} />
          <Route
            path=":pluginId"
            element={
              <PluginInstanceForm
                editedPluginInstances={editedPluginInstances}
                onChange={onChange}
                onStatusChange={(id, status, message) => {
                  setStatuses((prev) => ({
                    ...prev,
                    [id]: { status, message },
                  }));
                }}
                statuses={statuses}
                onRemove={(id) => {
                  setEditedPluginInstances((prev) => {
                    const next = { ...prev };
                    delete next[id];
                    return next;
                  });
                  setStatuses((prev) => {
                    const next = { ...prev };
                    delete next[id];
                    return next;
                  });
                }}
              />
            }
          />
        </Routes>
      </PageWrapperTwoColumn>
    </>
  );
};

export default PluginInstanceEditScreen;
